import { FormikErrors } from 'formik';

import steps from 'app/pages/Registration/steps';

import { IForm } from './utils';

type Reducer<S, A> = (prevState: S, action: A) => S;

interface State {
  activeStep: number;
}

export type Action = {
  errors: FormikErrors<IForm>;
  i: number;
};

const stepsLength = steps().length;

const reducer: Reducer<State, Action> = (state, action) => {
  const completed = Object.keys(action.errors).length === 0;
  let { activeStep } = state;
  if (action.i < activeStep) {
    activeStep = action.i === 0 ? 0 : action.i;
  } else if (action.i <= stepsLength - 1 && completed) {
    activeStep =
      state.activeStep === stepsLength - 1 ? stepsLength - 1 : action.i;
  }
  window.scrollTo({ top: 0, behavior: 'smooth' });

  return {
    activeStep,
  };
};

export default reducer;
